module.exports = __webpack_public_path__ + "static/testCase-337f445b583adaea128c0e075b16e9e3.svg";